module.exports = __webpack_public_path__ + "img/graphic_icon_data_.f59fc54b.png";